import { render, staticRenderFns } from "./myCode.vue?vue&type=template&id=0f0f2b32&scoped=true"
import script from "./myCode.vue?vue&type=script&lang=js"
export * from "./myCode.vue?vue&type=script&lang=js"
import style0 from "./myCode.vue?vue&type=style&index=0&id=0f0f2b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f2b32",
  null
  
)

export default component.exports